import React from 'react';
import Icon from '../../../components/AppIcon';

const EngagementAnalytics = () => {
  return (
    <div className="space-y-6">
      <div className="card">
        <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
          Member Engagement Analytics
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="p-4 rounded-lg bg-primary/10">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
              <span className="text-sm font-medium text-foreground">Participation Rate</span>
            </div>
            <p className="text-3xl font-heading font-bold text-foreground mb-1">71.5%</p>
            <p className="text-xs text-success">+5.2% vs last month</p>
          </div>
          <div className="p-4 rounded-lg bg-accent/10">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Award" size={20} color="var(--color-accent)" />
              <span className="text-sm font-medium text-foreground">Achievements Unlocked</span>
            </div>
            <p className="text-3xl font-heading font-bold text-foreground mb-1">2,847</p>
            <p className="text-xs text-success">+12.8% vs last month</p>
          </div>
          <div className="p-4 rounded-lg bg-success/10">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Heart" size={20} color="var(--color-success)" />
              <span className="text-sm font-medium text-foreground">Retention Correlation</span>
            </div>
            <p className="text-3xl font-heading font-bold text-foreground mb-1">+12.3%</p>
            <p className="text-xs text-muted-foreground">Improvement</p>
          </div>
          <div className="p-4 rounded-lg bg-warning/10">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Users" size={20} color="var(--color-warning)" />
              <span className="text-sm font-medium text-foreground">At-Risk Members</span>
            </div>
            <p className="text-3xl font-heading font-bold text-foreground mb-1">34</p>
            <p className="text-xs text-error">-8 vs last week</p>
          </div>
        </div>
      </div>

      {/* Predictive Modeling */}
      <div className="card bg-gradient-to-r from-primary/10 to-accent/10 border-2 border-primary/20">
        <h2 className="text-xl font-heading font-semibold text-foreground mb-4">
          Predictive At-Risk Member Identification
        </h2>
        <p className="text-sm text-muted-foreground mb-4">
          AI-powered analysis identifies members with declining engagement patterns
        </p>
        <div className="space-y-3">
          {[
            { name: 'John Smith', risk: 'High', lastActivity: '14 days ago', points: 450 },
            { name: 'Emily Davis', risk: 'Medium', lastActivity: '8 days ago', points: 1200 },
            { name: 'Michael Brown', risk: 'Medium', lastActivity: '10 days ago', points: 890 }
          ]?.map((member, index) => (
            <div key={index} className="p-3 rounded-lg border border-border bg-background">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-medium text-foreground">{member?.name}</h3>
                  <p className="text-xs text-muted-foreground">
                    Last activity: {member?.lastActivity} • {member?.points} points
                  </p>
                </div>
                <span
                  className={`px-3 py-1 rounded-full text-xs font-medium ${
                    member?.risk === 'High' ?'bg-error/20 text-error' :'bg-warning/20 text-warning'
                  }`}
                >
                  {member?.risk} Risk
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EngagementAnalytics;